import { render, staticRenderFns } from "./AnnotationCard.vue?vue&type=template&id=42afc04a&scoped=true"
import script from "./AnnotationCard.vue?vue&type=script&lang=js"
export * from "./AnnotationCard.vue?vue&type=script&lang=js"
import style0 from "./AnnotationCard.vue?vue&type=style&index=0&id=42afc04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42afc04a",
  null
  
)

export default component.exports